import * as React from 'react';
import '../../Css/Global/Global.css';
import InfoCard from '../Dashboard/InfoCard';
import {Grid } from "@mui/material";

import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';


import TableIcmsProdutos from './TableIcmsProdutos';
import BarChartIcmsPorProduto from './BarChartIcmsPorProduto';

import { IcmsPorProduto, DebitoIcmsProdutoGrafico } from './types';
import SpedStatusHandler from '../Dashboard/SpedStatusHandler';
  

const AnalisesResultadoBruto: React.FC = () => {

    const [loading, setLoading] = React.useState(true);

    const [spedFiscalIdSelecionado, setSpedFiscalIdSelecionado] = React.useState<number | null>(null);

    const [dadosProdutosIcms, setDadosProdutosIcms] = React.useState<IcmsPorProduto[]>([]);
    const [dadosDebitoIcms, setDadosDebitoIcms] = React.useState<{ produto: string; 'ICMS': number }[]>([]);
    const [dadosCreditoIcms, setDadosCreditoIcms] = React.useState<{ produto: string; 'ICMS': number }[]>([]);


    // React.useEffect(() => {
    //   if (Number(spedFiscalIdSelecionado) > 0){
    //     const fetchData = async () => {
    //       try {
    //         setLoading(true);
    //         const response = await fetch(process.env.REACT_APP_API_URL+'icms-por-produto/'+spedFiscalIdSelecionado);
    //         const data = await response.json();
      
    //         // Aqui você pode validar se os dados têm a estrutura esperada
    //         if (Array.isArray(data)) {
    //           setDadosProdutosIcms(data);
    //         } else {
    //           console.error('Dados de produtos inválidos:', data);
    //         }

    //         const responseGrafico1 = await fetch(process.env.REACT_APP_API_URL+'top-produtos-debitos-icms/'+spedFiscalIdSelecionado);
    //         const data1: DebitoIcmsProdutoGrafico[] = await responseGrafico1.json();

    //         if (Array.isArray(data1)) {
    //           // transforma os dados no formato esperado pelo gráfico de barras horizontais
    //           const formatado = data1.map(item => ({
    //             produto: `${item.descr_compl}`,
    //             'ICMS': item.total,
    //           }));
      
    //           setDadosDebitoIcms(formatado);
    //         } else {
    //           console.error('Dados de produtos inválidos:', data);
    //         }

    //         const responseGrafico2 = await fetch(process.env.REACT_APP_API_URL+'top-produtos-creditos-icms/'+spedFiscalIdSelecionado);
    //         const data2: DebitoIcmsProdutoGrafico[] = await responseGrafico2.json();

    //         if (Array.isArray(data2)) {
    //           // transforma os dados no formato esperado pelo gráfico de barras horizontais
    //           const formatado2 = data2.map(item => ({
    //             produto: `${item.descr_compl}`,
    //             'ICMS': item.total,
    //           }));
      
    //           setDadosCreditoIcms(formatado2);
    //         } else {
    //           console.error('Dados de produtos inválidos:', data);
    //         }

    //       } catch (e) {
    //         console.error('Erro ao carregar dados de produtos ICMS', e);
    //       } finally {
    //         setLoading(false);
    //       }
    //     };
      
    //     fetchData();
    //   }
    //   }, [spedFiscalIdSelecionado]);

    return (
        <>
            <Grid container spacing={0.5}>

              <SpedStatusHandler
                  onSpedFiscalIdChange={(id) => {
                      setSpedFiscalIdSelecionado(id);
                  }}
              />

              <InfoCard title="Análise de Resultado Bruto" icon={<AddShoppingCartIcon />} iconColor="info" size={12} loading={loading} />

              {/* <Grid item xs={12} md={6} lg={6}>
                <BarChartIcmsPorProduto
                  data={dadosDebitoIcms}
                  title="Top 10 Débitos de ICMS por Produto"  
                  barColor='#ff5252'
                  loading={loading}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <BarChartIcmsPorProduto
                  data={dadosCreditoIcms}
                  title="Top 10 Créditos de ICMS por Produto"  
                  barColor='#43a047'
                  loading={loading}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                  <TableIcmsProdutos data={dadosProdutosIcms} loading={loading} />
              </Grid> */}
            </Grid>              
        </>
      );
      
}

export default AnalisesResultadoBruto;

